import { useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

import { hasHistoryBehind } from '../../common/history';

/**
 * The leave-this-page handler every back and close control shares: one step
 * back through history where the page was reached in-app, so the reader
 * returns to the list, tab or filter they left, and the canonical parent page
 * where there is nothing behind to go back to.
 */
const useBackNavigation = () => {
  const navigate = useNavigate();

  return useCallback(
    (href: string) => {
      if (hasHistoryBehind()) {
        navigate(-1);
        return;
      }
      navigate(href);
    },
    [navigate]
  );
};

export default useBackNavigation;
